




























import { ProjectFolderDefault } from "@/api/project/project-folder-default-api";
import ProjectFolderDefaultTable from "@/components/project/property/ProjectFolderDefaultTable.vue";
import VToolbar from "@/components/VToolbar.vue";
import { Component, Vue } from "vue-property-decorator";

/**
 * 現場のプロパティキーの一覧ページ
 */
@Component({
  components: {
    VToolbar,
    ProjectFolderDefaultTable
  }
})
export default class ProjectFolderDefaultListPage extends Vue {
  keys: ProjectFolderDefault[] = [];

  public created() {
    this.$store.dispatch("folder_type/init");
  }

  get initKeys() {
    return this.$store.getters["folder_type/all"](this.$route.params.type);
  }

  sort(data: ProjectFolderDefault) {
    this.$store.dispatch("folder_type/sort", data);
  }

  remove(id: string) {
    this.$store.dispatch("folder_type/remove", id);
  }
}
